import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MenuCategoriesService from "../../services/MenuCategoriesService";

const EditCategories = (props) => {
  const { id } = useParams();
  let navigate = useNavigate();

  const initialCategoriesState = {
    id: null,
    name: "",
    description: "",
    image: null,
    type: "",
    published: false,
  };

  const itemtype = [
    { id: "food", name: "food" },
    { id: "drinks", name: "drinks" },
  ];

  const [categories, setCategories] = useState(initialCategoriesState);
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState("");
  const [alert, setAlert] = useState("alert alert-danger");
  const [image, setImage] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCategories({ ...categories, [name]: value });
  };

  const handleImageInputChange = (e) => {
    const { name, value } = e.target;
    const inputimage = e.target.files[0];
    setImage(inputimage);
    setCategories({ ...categories, [name]: inputimage });
  };
  const handleSelectInputChange = (e) => {
    const { name, value } = e.target;

    console.log("here : " + e.target.name);
    // setImage(inputimage)
    setCategories({
      ...categories,
      [name]: value,
    });
  };

  const getCategories = (id) => {
    MenuCategoriesService.get(id)

      .then((response) => {
        const data = response.data;

        setCategories(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if (id) getCategories(id);
  }, [id]);

  useEffect(() => {}, [categories]);

  const updateCategories = () => {
    MenuCategoriesService.update(categories.id, categories)
      .then((response) => {
        setServermessage("The FoodDrink was updated successfully!");
        setSubmitted(true);
        setAlert("alert alert-success");
        console.log(categories);
      })
      .catch((e) => {
        setServermessage("Error: " + e.response.data.message);
        setSubmitted(true);
        console.log(e);
      });
  };

  const deleteCategories = () => {
    MenuCategoriesService.remove(categories.id)
      .then((response) => {
        console.log(response.data);
        navigate("/admin/menucategories");
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // console.log("Current FNB: "+JSON.stringify(categories))

  return (
    <div className="container pb-10">
      {categories ? (
        <>
          <h1 className="text-1xl lg:text-1xl font-semibold py-10">
            {" "}
            {categories.name}
          </h1>
          <div>
            {submitted ? (
              <div
                className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"
                role="alert"
              >
                <p style={{ marginBottom: "0" }}>{servermessage}</p>
              </div>
            ) : (
              <>
                <p style={{ marginBottom: "0" }}>{servermessage}</p>
              </>
            )}
            <br></br>
          </div>

          <form className="w-full">
            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-full-name"
                >
                  Name
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  type="text"
                  id="name"
                  required
                  value={categories.name}
                  onChange={handleInputChange}
                  name="name"
                />
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-password"
                >
                  Description
                </label>
              </div>
              <div className="md:w-2/3">
                <textarea
                  rows="5"
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  id="description"
                  name="description"
                  type="text"
                  value={categories.description}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label
                  className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                  htmlFor="inline-password"
                >
                  Menu Type
                </label>
              </div>
              <div className="md:w-2/3">
                <select
                  id="type"
                  name="type"
                  type="text"
                  className="bg-gray-200  border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  value={categories.type}
                  onChange={handleSelectInputChange}
                >
                  <option>---</option>
                  {itemtype?.length > 0 &&
                    itemtype.map((item, index) => (
                      <option
                        value={item.id}
                        key={index}
                      >
                        {item.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">
                  Image
                </label>
              </div>
              <div className="md:w-2/3">
                <input
                  className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                  type="file"
                  id="image"
                  onChange={handleImageInputChange}
                  name="image"
                />
              </div>
            </div>
          </form>

          <div className="md:flex md:items-center">
            <div className="md:w-1/3"></div>
            <div className="md:w-2/3 grid grid-cols-2 gap-40">
              <button
                className="shadow bg-red-500 hover:bg-red-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                onClick={deleteCategories}
              >
                Delete
              </button>

              <button
                className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
                type="submit"
                onClick={updateCategories}
              >
                Update
              </button>
            </div>
          </div>
        </>
      ) : (
        <div>
          <br />
          <p>Please click on a FoodDrink...</p>
        </div>
      )}
    </div>
  );
};

export default EditCategories;
